import axios from "axios";

export const obtenerEstadoPago = async ({idPago}) => {

    let pago = {
        idPago: idPago,
    }

    let data = JSON.stringify(pago);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/44cf1b3a-281d-420a-b5f5-462513ece274', //test
          url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/44cf1b3a-281d-420a-b5f5-462513ece274',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)
        .then((response) => {

            //             console.log(response);

            return response.data[0]


        })
        .catch((error) => {
            let obj = {
                id: pago.id,
                exitoso: false,
                estado: 'Error en pago',
                detalle: 'Porfavor comunicate con nosotros',
                fecha: new Date(pago.date_created).getTime(),
                pagado: 0
            }

            return obj
        });


}